/** Entfernt optionale YAML-/SEO-Metadaten und einen führenden H1 aus einer Immobilien-Markdown-Datei. */
export function stripPropertyMarkdownMeta(raw: string): string {
  const text = raw.replace(/^\uFEFF/, "").trim();
  const frontMatter = text.match(/^---\s*\n[\s\S]*?\n---\s*\n?/);
  const withoutFrontMatter = frontMatter ? text.slice(frontMatter[0].length).trim() : text;

  // Der Objekttitel wird auf der Detailseite bereits als H1 gerendert.
  return withoutFrontMatter.replace(/^#\s+[^\n]+\n+/, "").trim();
}

/**
 * Wandelt übliche Google-Drive-Freigabelinks in die Rohtext-Download-URL um.
 * Bereits direkte HTTPS-URLs werden unverändert belassen.
 */
export function normalizePropertyMarkdownUrl(rawUrl: string): string {
  const url = rawUrl.trim();
  if (!/^https?:\/\//i.test(url)) return "";
  const fileId = url.match(/\/d\/([a-zA-Z0-9_-]+)/)?.[1] ?? url.match(/[?&]id=([a-zA-Z0-9_-]+)/)?.[1];
  return fileId && /(?:drive|docs)\.google\.com/i.test(url)
    ? `https://docs.google.com/uc?export=download&id=${fileId}`
    : url;
}
